export const footerLinks = {
  'ma-ar': [
    {
      title: 'أفضل الوجهات',
      items: [
        {
          href: 'https://ma.wingie.com/ar/flights/to-casablanca/',
          title: 'الدار البيضاء',
        },
        {
          href: 'https://ma.wingie.com/ar/flights/to-marrakech/',
          title: 'مراكش',
        },
        {
          href: 'https://ma.wingie.com/ar/flights/to-rabat/',
          title: 'الرباط',
        },
        {
          href: 'https://ma.wingie.com/ar/flights/to-fez/',
          title: 'فاس',
        },
        {
          href: 'https://ma.wingie.com/ar/flights/to-agadir/',
          title: 'أكادير',
        },
        {
          href: 'https://ma.wingie.com/ar/flights/to-paris/',
          title: 'باريس',
        },
      ],
    },
    {
      title: 'الدول الشعبية',
      items: [
        {
          href: 'https://ma.wingie.com/ar/flights/fr-france/',
          title: 'فرنسا',
        },
        {
          href: 'https://ma.wingie.com/ar/flights/es-spain/',
          title: 'إسبانيا',
        },
        {
          href: 'https://ma.wingie.com/ar/flights/it-italy/',
          title: 'إيطاليا',
        },
        {
          href: 'https://ma.wingie.com/ar/flights/de-germany/',
          title: 'ألمانيا',
        },
        {
          href: 'https://ma.wingie.com/ar/flights/tr-turkey/',
          title: 'تركيا',
        },
        {
          href: 'https://ma.wingie.com/ar/flights/ae-united-arab-emirates/',
          title: 'الإمارات العربية المتحدة',
        },
      ],
    },
    {
      title: 'شركات الطيران الشعبية',
      items: [
        {
          href: 'https://ma.wingie.com/ar/flights/airlines/royal-air-maroc/',
          title: 'الخطوط الملكية المغربية',
        },
        {
          href: 'https://ma.wingie.com/ar/flights/airlines/air-arabia-maroc/',
          title: 'العربية للطيران المغرب',
        },
        {
          href: 'https://ma.wingie.com/ar/flights/airlines/air-france/',
          title: 'الخطوط الجوية الفرنسية',
        },
        {
          href: 'https://ma.wingie.com/ar/flights/airlines/iberia/',
          title: 'إيبيريا',
        },
        {
          href: 'https://ma.wingie.com/ar/flights/airlines/turkish-airlines/',
          title: 'الخطوط الجوية التركية',
        },
        {
          href: 'https://ma.wingie.com/ar/flights/airlines/emirates/',
          title: 'طيران الإمارات',
        },
      ],
    },
  ],
  'ma-en': [
    {
      title: 'Top Destinations',
      items: [
        {
          href: 'https://ma.wingie.com/en/flights/to-casablanca/',
          title: 'Casablanca',
        },
        {
          href: 'https://ma.wingie.com/en/flights/to-marrakech/',
          title: 'Marrakech',
        },
        {
          href: 'https://ma.wingie.com/en/flights/to-rabat/',
          title: 'Rabat',
        },
        {
          href: 'https://ma.wingie.com/en/flights/to-fez/',
          title: 'Fez',
        },
        {
          href: 'https://ma.wingie.com/en/flights/to-agadir/',
          title: 'Agadir',
        },
        {
          href: 'https://ma.wingie.com/en/flights/to-paris/',
          title: 'Paris',
        },
      ],
    },
    {
      title: 'Popular Countries',
      items: [
        {
          href: 'https://ma.wingie.com/en/flights/fr-france/',
          title: 'France',
        },
        {
          href: 'https://ma.wingie.com/en/flights/es-spain/',
          title: 'Spain',
        },
        {
          href: 'https://ma.wingie.com/en/flights/it-italy/',
          title: 'Italy',
        },
        {
          href: 'https://ma.wingie.com/en/flights/de-germany/',
          title: 'Germany',
        },
        {
          href: 'https://ma.wingie.com/en/flights/tr-turkey/',
          title: 'Turkey',
        },
        {
          href: 'https://ma.wingie.com/en/flights/ae-united-arab-emirates/',
          title: 'United Arab Emirates',
        },
      ],
    },
    {
      title: 'Popular Airlines',
      items: [
        {
          href: 'https://ma.wingie.com/en/flights/airlines/royal-air-maroc/',
          title: 'Royal Air Maroc',
        },
        {
          href: 'https://ma.wingie.com/en/flights/airlines/air-arabia-maroc/',
          title: 'Air Arabia Maroc',
        },
        {
          href: 'https://ma.wingie.com/en/flights/airlines/air-france/',
          title: 'Air France',
        },
        {
          href: 'https://ma.wingie.com/en/flights/airlines/iberia/',
          title: 'Iberia',
        },
        {
          href: 'https://ma.wingie.com/en/flights/airlines/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://ma.wingie.com/en/flights/airlines/emirates/',
          title: 'Emirates',
        },
      ],
    },
  ],
  'ma-fr': [
    {
      title: 'Destinations principales',
      items: [
        {
          href: 'https://ma.wingie.com/fr/flights/to-casablanca/',
          title: 'Casablanca',
        },
        {
          href: 'https://ma.wingie.com/fr/flights/to-marrakech/',
          title: 'Marrakech',
        },
        {
          href: 'https://ma.wingie.com/fr/flights/to-rabat/',
          title: 'Rabat',
        },
        {
          href: 'https://ma.wingie.com/fr/flights/to-fez/',
          title: 'Fès',
        },
        {
          href: 'https://ma.wingie.com/fr/flights/to-agadir/',
          title: 'Agadir',
        },
        {
          href: 'https://ma.wingie.com/fr/flights/to-paris/',
          title: 'Paris',
        },
      ],
    },
    {
      title: 'Pays populaires',
      items: [
        {
          href: 'https://ma.wingie.com/fr/flights/fr-france/',
          title: 'France',
        },
        {
          href: 'https://ma.wingie.com/fr/flights/es-spain/',
          title: 'Espagne',
        },
        {
          href: 'https://ma.wingie.com/fr/flights/it-italy/',
          title: 'Italie',
        },
        {
          href: 'https://ma.wingie.com/fr/flights/de-germany/',
          title: 'Allemagne',
        },
        {
          href: 'https://ma.wingie.com/fr/flights/tr-turkey/',
          title: 'Turquie',
        },
        {
          href: 'https://ma.wingie.com/fr/flights/ae-united-arab-emirates/',
          title: 'Émirats arabes unis',
        },
      ],
    },
    {
      title: 'Compagnies aériennes populaires',
      items: [
        {
          href: 'https://ma.wingie.com/fr/flights/airlines/royal-air-maroc/',
          title: 'Royal Air Maroc',
        },
        {
          href: 'https://ma.wingie.com/fr/flights/airlines/air-arabia-maroc/',
          title: 'Air Arabia Maroc',
        },
        {
          href: 'https://ma.wingie.com/fr/flights/airlines/air-france/',
          title: 'Air France',
        },
        {
          href: 'https://ma.wingie.com/fr/flights/airlines/iberia/',
          title: 'Iberia',
        },
        {
          href: 'https://ma.wingie.com/fr/flights/airlines/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://ma.wingie.com/fr/flights/airlines/emirates/',
          title: 'Emirates',
        },
      ],
    },
  ],
  'ma-de': [
    {
      title: 'Top-Destinationen',
      items: [
        {
          href: 'https://ma.wingie.com/de/fluge/nach-casablanca/',
          title: 'Casablanca',
        },
        {
          href: 'https://ma.wingie.com/de/fluge/nach-marrakesch/',
          title: 'Marrakesch',
        },
        {
          href: 'https://ma.wingie.com/de/fluge/nach-rabat/',
          title: 'Rabat',
        },
        {
          href: 'https://ma.wingie.com/de/fluge/nach-fez/',
          title: 'Fez',
        },
        {
          href: 'https://ma.wingie.com/de/fluge/nach-agadir/',
          title: 'Agadir',
        },
        {
          href: 'https://ma.wingie.com/de/fluge/nach-paris/',
          title: 'Paris',
        },
      ],
    },
    {
      title: 'Beliebte Länder',
      items: [
        {
          href: 'https://ma.wingie.com/de/fluge/fr-frankreich/',
          title: 'Frankreich',
        },
        {
          href: 'https://ma.wingie.com/de/fluge/es-spanien/',
          title: 'Spanien',
        },
        {
          href: 'https://ma.wingie.com/de/fluge/it-italien/',
          title: 'Italien',
        },
        {
          href: 'https://ma.wingie.com/de/fluge/de-deutschland/',
          title: 'Deutschland',
        },
        {
          href: 'https://ma.wingie.com/de/fluge/tr-turkei/',
          title: 'Türkei',
        },
        {
          href: 'https://ma.wingie.com/de/fluge/ae-vereinigte-arabische-emirate/',
          title: 'Vereinigte Arabische Emirate',
        },
      ],
    },
    {
      title: 'Beliebte Fluggesellschaften',
      items: [
        {
          href: 'https://ma.wingie.com/de/fluge/fluggesellschaften/royal-air-maroc/',
          title: 'Royal Air Maroc',
        },
        {
          href: 'https://ma.wingie.com/de/fluge/fluggesellschaften/air-arabia-maroc/',
          title: 'Air Arabia Maroc',
        },
        {
          href: 'https://ma.wingie.com/de/fluge/fluggesellschaften/air-france/',
          title: 'Air France',
        },
        {
          href: 'https://ma.wingie.com/de/fluge/fluggesellschaften/iberia/',
          title: 'Iberia',
        },
        {
          href: 'https://ma.wingie.com/de/fluge/fluggesellschaften/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://ma.wingie.com/de/fluge/fluggesellschaften/emirates/',
          title: 'Emirates',
        },
      ],
    },
  ],
  'ma-es': [
    {
      title: 'Destinos principales',
      items: [
        {
          href: 'https://ma.wingie.com/es/vuelos/a-casablanca/',
          title: 'Casablanca',
        },
        {
          href: 'https://ma.wingie.com/es/vuelos/a-marrakech/',
          title: 'Marrakech',
        },
        {
          href: 'https://ma.wingie.com/es/vuelos/a-rabat/',
          title: 'Rabat',
        },
        {
          href: 'https://ma.wingie.com/es/vuelos/a-fez/',
          title: 'Fez',
        },
        {
          href: 'https://ma.wingie.com/es/vuelos/a-agadir/',
          title: 'Agadir',
        },
        {
          href: 'https://ma.wingie.com/es/vuelos/a-paris/',
          title: 'París',
        },
      ],
    },
    {
      title: 'Países populares',
      items: [
        {
          href: 'https://ma.wingie.com/es/vuelos/fr-francia/',
          title: 'Francia',
        },
        {
          href: 'https://ma.wingie.com/es/vuelos/es-espana/',
          title: 'España',
        },
        {
          href: 'https://ma.wingie.com/es/vuelos/it-italia/',
          title: 'Italia',
        },
        {
          href: 'https://ma.wingie.com/es/vuelos/de-alemania/',
          title: 'Alemania',
        },
        {
          href: 'https://ma.wingie.com/es/vuelos/tr-turquia/',
          title: 'Turquía',
        },
        {
          href: 'https://ma.wingie.com/es/vuelos/ae-emiratos-arabes-unidos/',
          title: 'Emiratos Árabes Unidos',
        },
      ],
    },
    {
      title: 'Aerolíneas populares',
      items: [
        {
          href: 'https://ma.wingie.com/es/vuelos/aerolineas/royal-air-maroc/',
          title: 'Royal Air Maroc',
        },
        {
          href: 'https://ma.wingie.com/es/vuelos/aerolineas/air-arabia-maroc/',
          title: 'Air Arabia Maroc',
        },
        {
          href: 'https://ma.wingie.com/es/vuelos/aerolineas/air-france/',
          title: 'Air France',
        },
        {
          href: 'https://ma.wingie.com/es/vuelos/aerolineas/iberia/',
          title: 'Iberia',
        },
        {
          href: 'https://ma.wingie.com/es/vuelos/aerolineas/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://ma.wingie.com/es/vuelos/aerolineas/emirates/',
          title: 'Emirates',
        },
      ],
    },
  ],
  'ma-it': [
    {
      title: 'Destinazioni principali',
      items: [
        {
          href: 'https://ma.wingie.com/it/flights/to-casablanca/',
          title: 'Casablanca',
        },
        {
          href: 'https://ma.wingie.com/it/flights/to-marrakech/',
          title: 'Marrakech',
        },
        {
          href: 'https://ma.wingie.com/it/flights/to-rabat/',
          title: 'Rabat',
        },
        {
          href: 'https://ma.wingie.com/it/flights/to-fez/',
          title: 'Fez',
        },
        {
          href: 'https://ma.wingie.com/it/flights/to-agadir/',
          title: 'Agadir',
        },
        {
          href: 'https://ma.wingie.com/it/flights/to-paris/',
          title: 'Parigi',
        },
      ],
    },
    {
      title: 'Paesi popolari',
      items: [
        {
          href: 'https://ma.wingie.com/it/flights/fr-france/',
          title: 'Francia',
        },
        {
          href: 'https://ma.wingie.com/it/flights/es-spain/',
          title: 'Spagna',
        },
        {
          href: 'https://ma.wingie.com/it/flights/it-italy/',
          title: 'Italia',
        },
        {
          href: 'https://ma.wingie.com/it/flights/de-germany/',
          title: 'Germania',
        },
        {
          href: 'https://ma.wingie.com/it/flights/tr-turkey/',
          title: 'Turchia',
        },
        {
          href: 'https://ma.wingie.com/it/flights/ae-united-arab-emirates/',
          title: 'Emirati Arabi Uniti',
        },
      ],
    },
    {
      title: 'Compagnie aeree popolari',
      items: [
        {
          href: 'https://ma.wingie.com/it/flights/airlines/royal-air-maroc/',
          title: 'Royal Air Maroc',
        },
        {
          href: 'https://ma.wingie.com/it/flights/airlines/air-arabia-maroc/',
          title: 'Air Arabia Maroc',
        },
        {
          href: 'https://ma.wingie.com/it/flights/airlines/air-france/',
          title: 'Air France',
        },
        {
          href: 'https://ma.wingie.com/it/flights/airlines/iberia/',
          title: 'Iberia',
        },
        {
          href: 'https://ma.wingie.com/it/flights/airlines/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://ma.wingie.com/it/flights/airlines/emirates/',
          title: 'Emirates',
        },
      ],
    },
  ],
  'ma-ru': [
    {
      title: 'Популярные направления',
      items: [
        {
          href: 'https://ma.wingie.com/ru/flights/to-casablanca/',
          title: 'Касабланка',
        },
        {
          href: 'https://ma.wingie.com/ru/flights/to-marrakech/',
          title: 'Марракеш',
        },
        {
          href: 'https://ma.wingie.com/ru/flights/to-rabat/',
          title: 'Рабат',
        },
        {
          href: 'https://ma.wingie.com/ru/flights/to-fez/',
          title: 'Фес',
        },
        {
          href: 'https://ma.wingie.com/ru/flights/to-agadir/',
          title: 'Агадир',
        },
        {
          href: 'https://ma.wingie.com/ru/flights/to-paris/',
          title: 'Париж',
        },
      ],
    },
    {
      title: 'Популярные страны',
      items: [
        {
          href: 'https://ma.wingie.com/ru/flights/fr-france/',
          title: 'Франция',
        },
        {
          href: 'https://ma.wingie.com/ru/flights/es-spain/',
          title: 'Испания',
        },
        {
          href: 'https://ma.wingie.com/ru/flights/it-italy/',
          title: 'Италия',
        },
        {
          href: 'https://ma.wingie.com/ru/flights/de-germany/',
          title: 'Германия',
        },
        {
          href: 'https://ma.wingie.com/ru/flights/tr-turkey/',
          title: 'Турция',
        },
        {
          href: 'https://ma.wingie.com/ru/flights/ae-united-arab-emirates/',
          title: 'ОАЭ',
        },
      ],
    },
    {
      title: 'Популярные авиакомпании',
      items: [
        {
          href: 'https://ma.wingie.com/ru/flights/airlines/royal-air-maroc/',
          title: 'Royal Air Maroc',
        },
        {
          href: 'https://ma.wingie.com/ru/flights/airlines/air-arabia-maroc/',
          title: 'Air Arabia Maroc',
        },
        {
          href: 'https://ma.wingie.com/ru/flights/airlines/air-france/',
          title: 'Air France',
        },
        {
          href: 'https://ma.wingie.com/ru/flights/airlines/iberia/',
          title: 'Iberia',
        },
        {
          href: 'https://ma.wingie.com/ru/flights/airlines/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://ma.wingie.com/ru/flights/airlines/emirates/',
          title: 'Emirates',
        },
      ],
    },
  ],
  'ma-pt': [
    {
      title: 'Destinos principais',
      items: [
        {
          href: 'https://ma.wingie.com/pt/flights/to-casablanca/',
          title: 'Casablanca',
        },
        {
          href: 'https://ma.wingie.com/pt/flights/to-marrakech/',
          title: 'Marrakech',
        },
        {
          href: 'https://ma.wingie.com/pt/flights/to-rabat/',
          title: 'Rabat',
        },
        {
          href: 'https://ma.wingie.com/pt/flights/to-fez/',
          title: 'Fez',
        },
        {
          href: 'https://ma.wingie.com/pt/flights/to-agadir/',
          title: 'Agadir',
        },
        {
          href: 'https://ma.wingie.com/pt/flights/to-paris/',
          title: 'Paris',
        },
      ],
    },
    {
      title: 'Países populares',
      items: [
        {
          href: 'https://ma.wingie.com/pt/flights/fr-france/',
          title: 'França',
        },
        {
          href: 'https://ma.wingie.com/pt/flights/es-spain/',
          title: 'Espanha',
        },
        {
          href: 'https://ma.wingie.com/pt/flights/it-italy/',
          title: 'Itália',
        },
        {
          href: 'https://ma.wingie.com/pt/flights/de-germany/',
          title: 'Alemanha',
        },
        {
          href: 'https://ma.wingie.com/pt/flights/tr-turkey/',
          title: 'Turquia',
        },
        {
          href: 'https://ma.wingie.com/pt/flights/ae-united-arab-emirates/',
          title: 'Emirados Árabes Unidos',
        },
      ],
    },
    {
      title: 'Companhias aéreas populares',
      items: [
        {
          href: 'https://ma.wingie.com/pt/flights/airlines/royal-air-maroc/',
          title: 'Royal Air Maroc',
        },
        {
          href: 'https://ma.wingie.com/pt/flights/airlines/air-arabia-maroc/',
          title: 'Air Arabia Maroc',
        },
        {
          href: 'https://ma.wingie.com/pt/flights/airlines/air-france/',
          title: 'Air France',
        },
        {
          href: 'https://ma.wingie.com/pt/flights/airlines/iberia/',
          title: 'Iberia',
        },
        {
          href: 'https://ma.wingie.com/pt/flights/airlines/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://ma.wingie.com/pt/flights/airlines/emirates/',
          title: 'Emirates',
        },
      ],
    },
  ],
  'ma-ro': [
    {
      title: 'Destinații principale',
      items: [
        {
          href: 'https://ma.wingie.com/ro/flights/to-casablanca/',
          title: 'Casablanca',
        },
        {
          href: 'https://ma.wingie.com/ro/flights/to-marrakech/',
          title: 'Marrakech',
        },
        {
          href: 'https://ma.wingie.com/ro/flights/to-rabat/',
          title: 'Rabat',
        },
        {
          href: 'https://ma.wingie.com/ro/flights/to-fez/',
          title: 'Fez',
        },
        {
          href: 'https://ma.wingie.com/ro/flights/to-agadir/',
          title: 'Agadir',
        },
        {
          href: 'https://ma.wingie.com/ro/flights/to-paris/',
          title: 'Paris',
        },
      ],
    },
    {
      title: 'Țări populare',
      items: [
        {
          href: 'https://ma.wingie.com/ro/flights/fr-france/',
          title: 'Franța',
        },
        {
          href: 'https://ma.wingie.com/ro/flights/es-spain/',
          title: 'Spania',
        },
        {
          href: 'https://ma.wingie.com/ro/flights/it-italy/',
          title: 'Italia',
        },
        {
          href: 'https://ma.wingie.com/ro/flights/de-germany/',
          title: 'Germania',
        },
        {
          href: 'https://ma.wingie.com/ro/flights/tr-turkey/',
          title: 'Turcia',
        },
        {
          href: 'https://ma.wingie.com/ro/flights/ae-united-arab-emirates/',
          title: 'Emiratele Arabe Unite',
        },
      ],
    },
    {
      title: 'Companii aeriene populare',
      items: [
        {
          href: 'https://ma.wingie.com/ro/flights/airlines/royal-air-maroc/',
          title: 'Royal Air Maroc',
        },
        {
          href: 'https://ma.wingie.com/ro/flights/airlines/air-arabia-maroc/',
          title: 'Air Arabia Maroc',
        },
        {
          href: 'https://ma.wingie.com/ro/flights/airlines/air-france/',
          title: 'Air France',
        },
        {
          href: 'https://ma.wingie.com/ro/flights/airlines/iberia/',
          title: 'Iberia',
        },
        {
          href: 'https://ma.wingie.com/ro/flights/airlines/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://ma.wingie.com/ro/flights/airlines/emirates/',
          title: 'Emirates',
        },
      ],
    },
  ],
  'ma-pl': [
    {
      title: 'Popularne kierunki',
      items: [
        {
          href: 'https://ma.wingie.com/pl/flights/to-casablanca/',
          title: 'Casablanca',
        },
        {
          href: 'https://ma.wingie.com/pl/flights/to-marrakech/',
          title: 'Marrakech',
        },
        {
          href: 'https://ma.wingie.com/pl/flights/to-rabat/',
          title: 'Rabat',
        },
        {
          href: 'https://ma.wingie.com/pl/flights/to-fez/',
          title: 'Fez',
        },
        {
          href: 'https://ma.wingie.com/pl/flights/to-agadir/',
          title: 'Agadir',
        },
        {
          href: 'https://ma.wingie.com/pl/flights/to-paris/',
          title: 'Paryż',
        },
      ],
    },
    {
      title: 'Popularne kraje',
      items: [
        {
          href: 'https://ma.wingie.com/pl/flights/fr-france/',
          title: 'Francja',
        },
        {
          href: 'https://ma.wingie.com/pl/flights/es-spain/',
          title: 'Hiszpania',
        },
        {
          href: 'https://ma.wingie.com/pl/flights/it-italy/',
          title: 'Włochy',
        },
        {
          href: 'https://ma.wingie.com/pl/flights/de-germany/',
          title: 'Niemcy',
        },
        {
          href: 'https://ma.wingie.com/pl/flights/tr-turkey/',
          title: 'Turcja',
        },
        {
          href: 'https://ma.wingie.com/pl/flights/ae-united-arab-emirates/',
          title: 'Zjednoczone Emiraty Arabskie',
        },
      ],
    },
    {
      title: 'Popularne linie lotnicze',
      items: [
        {
          href: 'https://ma.wingie.com/pl/flights/airlines/royal-air-maroc/',
          title: 'Royal Air Maroc',
        },
        {
          href: 'https://ma.wingie.com/pl/flights/airlines/air-arabia-maroc/',
          title: 'Air Arabia Maroc',
        },
        {
          href: 'https://ma.wingie.com/pl/flights/airlines/air-france/',
          title: 'Air France',
        },
        {
          href: 'https://ma.wingie.com/pl/flights/airlines/iberia/',
          title: 'Iberia',
        },
        {
          href: 'https://ma.wingie.com/pl/flights/airlines/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://ma.wingie.com/pl/flights/airlines/emirates/',
          title: 'Emirates',
        },
      ],
    },
  ],
  'ma-lt': [
    {
      title: 'Populiarūs kryptys',
      items: [
        {
          href: 'https://ma.wingie.com/lt/flights/to-casablanca/',
          title: 'Kasablanka',
        },
        {
          href: 'https://ma.wingie.com/lt/flights/to-marrakech/',
          title: 'Marakešas',
        },
        {
          href: 'https://ma.wingie.com/lt/flights/to-rabat/',
          title: 'Rabatas',
        },
        {
          href: 'https://ma.wingie.com/lt/flights/to-fez/',
          title: 'Fesas',
        },
        {
          href: 'https://ma.wingie.com/lt/flights/to-agadir/',
          title: 'Agadiras',
        },
        {
          href: 'https://ma.wingie.com/lt/flights/to-paris/',
          title: 'Paryžius',
        },
      ],
    },
    {
      title: 'Populiarios šalys',
      items: [
        {
          href: 'https://ma.wingie.com/lt/flights/fr-france/',
          title: 'Prancūzija',
        },
        {
          href: 'https://ma.wingie.com/lt/flights/es-spain/',
          title: 'Ispanija',
        },
        {
          href: 'https://ma.wingie.com/lt/flights/it-italy/',
          title: 'Italija',
        },
        {
          href: 'https://ma.wingie.com/lt/flights/de-germany/',
          title: 'Vokietija',
        },
        {
          href: 'https://ma.wingie.com/lt/flights/tr-turkey/',
          title: 'Turkija',
        },
        {
          href: 'https://ma.wingie.com/lt/flights/ae-united-arab-emirates/',
          title: 'Jungtiniai Arabų Emyratai',
        },
      ],
    },
    {
      title: 'Populiarūs oro vežėjai',
      items: [
        {
          href: 'https://ma.wingie.com/lt/flights/airlines/royal-air-maroc/',
          title: 'Royal Air Maroc',
        },
        {
          href: 'https://ma.wingie.com/lt/flights/airlines/air-arabia-maroc/',
          title: 'Air Arabia Maroc',
        },
        {
          href: 'https://ma.wingie.com/lt/flights/airlines/air-france/',
          title: 'Air France',
        },
        {
          href: 'https://ma.wingie.com/lt/flights/airlines/iberia/',
          title: 'Iberia',
        },
        {
          href: 'https://ma.wingie.com/lt/flights/airlines/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://ma.wingie.com/lt/flights/airlines/emirates/',
          title: 'Emirates',
        },
      ],
    },
  ],
  'ma-uz': [
    {
      title: "Mashhur yo'nalishlar",
      items: [
        {
          href: 'https://ma.wingie.com/uz/flights/to-casablanca/',
          title: 'Kasablanka',
        },
        {
          href: 'https://ma.wingie.com/uz/flights/to-marrakech/',
          title: 'Marrakech',
        },
        {
          href: 'https://ma.wingie.com/uz/flights/to-rabat/',
          title: 'Rabat',
        },
        {
          href: 'https://ma.wingie.com/uz/flights/to-fez/',
          title: 'Fez',
        },
        {
          href: 'https://ma.wingie.com/uz/flights/to-agadir/',
          title: 'Agadir',
        },
        {
          href: 'https://ma.wingie.com/uz/flights/to-paris/',
          title: 'Parij',
        },
      ],
    },
    {
      title: 'Mashhur mamlakatlar',
      items: [
        {
          href: 'https://ma.wingie.com/uz/flights/fr-france/',
          title: 'Fransiya',
        },
        {
          href: 'https://ma.wingie.com/uz/flights/es-spain/',
          title: 'Ispaniya',
        },
        {
          href: 'https://ma.wingie.com/uz/flights/it-italy/',
          title: 'Italiya',
        },
        {
          href: 'https://ma.wingie.com/uz/flights/de-germany/',
          title: 'Germaniya',
        },
        {
          href: 'https://ma.wingie.com/uz/flights/tr-turkey/',
          title: 'Turkiya',
        },
        {
          href: 'https://ma.wingie.com/uz/flights/ae-united-arab-emirates/',
          title: 'Birlashgan Arab Amirliklari',
        },
      ],
    },
    {
      title: 'Mashhur aviakompaniyalar',
      items: [
        {
          href: 'https://ma.wingie.com/uz/flights/airlines/royal-air-maroc/',
          title: 'Royal Air Maroc',
        },
        {
          href: 'https://ma.wingie.com/uz/flights/airlines/air-arabia-maroc/',
          title: 'Air Arabia Maroc',
        },
        {
          href: 'https://ma.wingie.com/uz/flights/airlines/air-france/',
          title: 'Air France',
        },
        {
          href: 'https://ma.wingie.com/uz/flights/airlines/iberia/',
          title: 'Iberia',
        },
        {
          href: 'https://ma.wingie.com/uz/flights/airlines/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://ma.wingie.com/uz/flights/airlines/emirates/',
          title: 'Emirates',
        },
      ],
    },
  ],
  'ma-sr': [
    {
      title: 'Популарне дестинације',
      items: [
        {
          href: 'https://ma.wingie.com/sr/flights/to-casablanca/',
          title: 'Казабланка',
        },
        {
          href: 'https://ma.wingie.com/sr/flights/to-marrakech/',
          title: 'Маракеш',
        },
        {
          href: 'https://ma.wingie.com/sr/flights/to-rabat/',
          title: 'Рабат',
        },
        {
          href: 'https://ma.wingie.com/sr/flights/to-fez/',
          title: 'Фез',
        },
        {
          href: 'https://ma.wingie.com/sr/flights/to-agadir/',
          title: 'Агадир',
        },
        {
          href: 'https://ma.wingie.com/sr/flights/to-paris/',
          title: 'Париз',
        },
      ],
    },
    {
      title: 'Популарне земље',
      items: [
        {
          href: 'https://ma.wingie.com/sr/flights/fr-france/',
          title: 'Француска',
        },
        {
          href: 'https://ma.wingie.com/sr/flights/es-spain/',
          title: 'Шпанија',
        },
        {
          href: 'https://ma.wingie.com/sr/flights/it-italy/',
          title: 'Италија',
        },
        {
          href: 'https://ma.wingie.com/sr/flights/de-germany/',
          title: 'Немачка',
        },
        {
          href: 'https://ma.wingie.com/sr/flights/tr-turkey/',
          title: 'Турска',
        },
        {
          href: 'https://ma.wingie.com/sr/flights/ae-united-arab-emirates/',
          title: 'Уједињени Арапски Емирати',
        },
      ],
    },
    {
      title: 'Популарне авио-компаније',
      items: [
        {
          href: 'https://ma.wingie.com/sr/flights/airlines/royal-air-maroc/',
          title: 'Royal Air Maroc',
        },
        {
          href: 'https://ma.wingie.com/sr/flights/airlines/air-arabia-maroc/',
          title: 'Air Arabia Maroc',
        },
        {
          href: 'https://ma.wingie.com/sr/flights/airlines/air-france/',
          title: 'Air France',
        },
        {
          href: 'https://ma.wingie.com/sr/flights/airlines/iberia/',
          title: 'Iberia',
        },
        {
          href: 'https://ma.wingie.com/sr/flights/airlines/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://ma.wingie.com/sr/flights/airlines/emirates/',
          title: 'Emirates',
        },
      ],
    },
  ],
  'ma-ky': [
    {
      title: 'Популярдуу багыттар',
      items: [
        {
          href: 'https://ma.wingie.com/ky/flights/to-casablanca/',
          title: 'Касабланка',
        },
        {
          href: 'https://ma.wingie.com/ky/flights/to-marrakech/',
          title: 'Марракеш',
        },
        {
          href: 'https://ma.wingie.com/ky/flights/to-rabat/',
          title: 'Рабат',
        },
        {
          href: 'https://ma.wingie.com/ky/flights/to-fez/',
          title: 'Фез',
        },
        {
          href: 'https://ma.wingie.com/ky/flights/to-agadir/',
          title: 'Агадир',
        },
        {
          href: 'https://ma.wingie.com/ky/flights/to-paris/',
          title: 'Париж',
        },
      ],
    },
    {
      title: 'Популярдуу өлкөлөр',
      items: [
        {
          href: 'https://ma.wingie.com/ky/flights/fr-france/',
          title: 'Франция',
        },
        {
          href: 'https://ma.wingie.com/ky/flights/es-spain/',
          title: 'Испания',
        },
        {
          href: 'https://ma.wingie.com/ky/flights/it-italy/',
          title: 'Италия',
        },
        {
          href: 'https://ma.wingie.com/ky/flights/de-germany/',
          title: 'Германия',
        },
        {
          href: 'https://ma.wingie.com/ky/flights/tr-turkey/',
          title: 'Түркия',
        },
        {
          href: 'https://ma.wingie.com/ky/flights/ae-united-arab-emirates/',
          title: 'Бириккен Араб Эмиратары',
        },
      ],
    },
    {
      title: 'Популярдуу авиакомпаниялар',
      items: [
        {
          href: 'https://ma.wingie.com/ky/flights/airlines/royal-air-maroc/',
          title: 'Royal Air Maroc',
        },
        {
          href: 'https://ma.wingie.com/ky/flights/airlines/air-arabia-maroc/',
          title: 'Air Arabia Maroc',
        },
        {
          href: 'https://ma.wingie.com/ky/flights/airlines/air-france/',
          title: 'Air France',
        },
        {
          href: 'https://ma.wingie.com/ky/flights/airlines/iberia/',
          title: 'Iberia',
        },
        {
          href: 'https://ma.wingie.com/ky/flights/airlines/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://ma.wingie.com/ky/flights/airlines/emirates/',
          title: 'Emirates',
        },
      ],
    },
  ],
  'ma-tg': [
    {
      title: 'Самтҳои маъмул',
      items: [
        {
          href: 'https://ma.wingie.com/tg/flights/to-casablanca/',
          title: 'Касабланка',
        },
        {
          href: 'https://ma.wingie.com/tg/flights/to-marrakech/',
          title: 'Марракеш',
        },
        {
          href: 'https://ma.wingie.com/tg/flights/to-rabat/',
          title: 'Рабат',
        },
        {
          href: 'https://ma.wingie.com/tg/flights/to-fez/',
          title: 'Фез',
        },
        {
          href: 'https://ma.wingie.com/tg/flights/to-agadir/',
          title: 'Агадир',
        },
        {
          href: 'https://ma.wingie.com/tg/flights/to-paris/',
          title: 'Париж',
        },
      ],
    },
    {
      title: 'Кишварҳои маъмул',
      items: [
        {
          href: 'https://ma.wingie.com/tg/flights/fr-france/',
          title: 'Франсия',
        },
        {
          href: 'https://ma.wingie.com/tg/flights/es-spain/',
          title: 'Испания',
        },
        {
          href: 'https://ma.wingie.com/tg/flights/it-italy/',
          title: 'Италия',
        },
        {
          href: 'https://ma.wingie.com/tg/flights/de-germany/',
          title: 'Олмон',
        },
        {
          href: 'https://ma.wingie.com/tg/flights/tr-turkey/',
          title: 'Туркия',
        },
        {
          href: 'https://ma.wingie.com/tg/flights/ae-united-arab-emirates/',
          title: 'Аморати Муттаҳидаи Араб',
        },
      ],
    },
    {
      title: 'Ширкатҳои маъмули ҳавопаймоӣ',
      items: [
        {
          href: 'https://ma.wingie.com/tg/flights/airlines/royal-air-maroc/',
          title: 'Royal Air Maroc',
        },
        {
          href: 'https://ma.wingie.com/tg/flights/airlines/air-arabia-maroc/',
          title: 'Air Arabia Maroc',
        },
        {
          href: 'https://ma.wingie.com/tg/flights/airlines/air-france/',
          title: 'Air France',
        },
        {
          href: 'https://ma.wingie.com/tg/flights/airlines/iberia/',
          title: 'Iberia',
        },
        {
          href: 'https://ma.wingie.com/tg/flights/airlines/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://ma.wingie.com/tg/flights/airlines/emirates/',
          title: 'Emirates',
        },
      ],
    },
  ],
  'ma-kk': [
    {
      title: 'Танымал бағыттар',
      items: [
        {
          href: 'https://ma.wingie.com/kk/flights/to-casablanca/',
          title: 'Касабланка',
        },
        {
          href: 'https://ma.wingie.com/kk/flights/to-marrakech/',
          title: 'Марракеш',
        },
        {
          href: 'https://ma.wingie.com/kk/flights/to-rabat/',
          title: 'Рабат',
        },
        {
          href: 'https://ma.wingie.com/kk/flights/to-fez/',
          title: 'Фез',
        },
        {
          href: 'https://ma.wingie.com/kk/flights/to-agadir/',
          title: 'Агадир',
        },
        {
          href: 'https://ma.wingie.com/kk/flights/to-paris/',
          title: 'Париж',
        },
      ],
    },
    {
      title: 'Танымал елдер',
      items: [
        {
          href: 'https://ma.wingie.com/kk/flights/fr-france/',
          title: 'Франция',
        },
        {
          href: 'https://ma.wingie.com/kk/flights/es-spain/',
          title: 'Испания',
        },
        {
          href: 'https://ma.wingie.com/kk/flights/it-italy/',
          title: 'Италия',
        },
        {
          href: 'https://ma.wingie.com/kk/flights/de-germany/',
          title: 'Германия',
        },
        {
          href: 'https://ma.wingie.com/kk/flights/tr-turkey/',
          title: 'Түркия',
        },
        {
          href: 'https://ma.wingie.com/kk/flights/ae-united-arab-emirates/',
          title: 'Біріккен Араб Әмірліктері',
        },
      ],
    },
    {
      title: 'Танымал авиакомпаниялар',
      items: [
        {
          href: 'https://ma.wingie.com/kk/flights/airlines/royal-air-maroc/',
          title: 'Royal Air Maroc',
        },
        {
          href: 'https://ma.wingie.com/kk/flights/airlines/air-arabia-maroc/',
          title: 'Air Arabia Maroc',
        },
        {
          href: 'https://ma.wingie.com/kk/flights/airlines/air-france/',
          title: 'Air France',
        },
        {
          href: 'https://ma.wingie.com/kk/flights/airlines/iberia/',
          title: 'Iberia',
        },
        {
          href: 'https://ma.wingie.com/kk/flights/airlines/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://ma.wingie.com/kk/flights/airlines/emirates/',
          title: 'Emirates',
        },
      ],
    },
  ],
  'ma-nl': [
    {
      title: 'Populaire bestemmingen',
      items: [
        {
          href: 'https://ma.wingie.com/nl/flights/to-casablanca/',
          title: 'Casablanca',
        },
        {
          href: 'https://ma.wingie.com/nl/flights/to-marrakech/',
          title: 'Marrakech',
        },
        {
          href: 'https://ma.wingie.com/nl/flights/to-rabat/',
          title: 'Rabat',
        },
        {
          href: 'https://ma.wingie.com/nl/flights/to-fez/',
          title: 'Fez',
        },
        {
          href: 'https://ma.wingie.com/nl/flights/to-agadir/',
          title: 'Agadir',
        },
        {
          href: 'https://ma.wingie.com/nl/flights/to-paris/',
          title: 'Parijs',
        },
      ],
    },
    {
      title: 'Populaire landen',
      items: [
        {
          href: 'https://ma.wingie.com/nl/flights/fr-france/',
          title: 'Frankrijk',
        },
        {
          href: 'https://ma.wingie.com/nl/flights/es-spain/',
          title: 'Spanje',
        },
        {
          href: 'https://ma.wingie.com/nl/flights/it-italy/',
          title: 'Italië',
        },
        {
          href: 'https://ma.wingie.com/nl/flights/de-germany/',
          title: 'Duitsland',
        },
        {
          href: 'https://ma.wingie.com/nl/flights/tr-turkey/',
          title: 'Turkije',
        },
        {
          href: 'https://ma.wingie.com/nl/flights/ae-united-arab-emirates/',
          title: 'Verenigde Arabische Emiraten',
        },
      ],
    },
    {
      title: 'Populaire luchtvaartmaatschappijen',
      items: [
        {
          href: 'https://ma.wingie.com/nl/flights/airlines/royal-air-maroc/',
          title: 'Royal Air Maroc',
        },
        {
          href: 'https://ma.wingie.com/nl/flights/airlines/air-arabia-maroc/',
          title: 'Air Arabia Maroc',
        },
        {
          href: 'https://ma.wingie.com/nl/flights/airlines/air-france/',
          title: 'Air France',
        },
        {
          href: 'https://ma.wingie.com/nl/flights/airlines/iberia/',
          title: 'Iberia',
        },
        {
          href: 'https://ma.wingie.com/nl/flights/airlines/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://ma.wingie.com/nl/flights/airlines/emirates/',
          title: 'Emirates',
        },
      ],
    },
  ],
    'ma-ja': [
        {
            title: '人気の目的地',
            items: [
                { title: 'ラスベガス', href: 'https://ma.wingie.com/ja/flights/to-las-vegas/' },
                { title: 'シカゴ', href: 'https://ma.wingie.com/ja/flights/to-chicago/' },
                { title: 'マイアミ', href: 'https://ma.wingie.com/ja/flights/to-miami/' },
                { title: 'カンクン', href: 'https://ma.wingie.com/ja/flights/to-cancun/' },
                { title: 'ロンドン', href: 'https://ma.wingie.com/ja/flights/to-london/' },
                { title: 'ホノルル', href: 'https://ma.wingie.com/ja/flights/to-honolulu/' },
            ],
        },
        {
            title: '人気の国',
            items: [
                { title: 'カナダ', href: 'https://ma.wingie.com/ja/flights/ca-canada/' },
                { title: '中国', href: 'https://ma.wingie.com/ja/flights/cn-china/' },
                { title: 'コスタリカ', href: 'https://ma.wingie.com/ja/flights/cr-costa-rica/' },
                { title: 'ドミニカ共和国', href: 'https://ma.wingie.com/ja/flights/do-dominican-republic/' },
                { title: 'エルサルバドル', href: 'https://ma.wingie.com/ja/flights/sv-el-salvador/' },
                { title: 'フランス', href: 'https://ma.wingie.com/ja/flights/fr-france/' },
            ],
        },
        {
            title: '人気の航空会社',
            items: [
                { title: 'アメリカン・エアラインズ', href: 'https://ma.wingie.com/ja/flights/airlines/american-airlines/' },
                { title: 'デルタ航空', href: 'https://ma.wingie.com/ja/flights/airlines/delta-air-lines/' },
                { title: 'ユナイテッド航空', href: 'https://ma.wingie.com/ja/flights/airlines/united-airlines/' },
                { title: 'アラスカ航空', href: 'https://ma.wingie.com/ja/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://ma.wingie.com/ja/flights/airlines/jetblue/' },
                { title: 'ハワイアン航空', href: 'https://ma.wingie.com/ja/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'ma-zh': [
        {
            title: '热门目的地',
            items: [
                { title: '拉斯维加斯', href: 'https://ma.wingie.com/zh/flights/to-las-vegas/' },
                { title: '芝加哥', href: 'https://ma.wingie.com/zh/flights/to-chicago/' },
                { title: '迈阿密', href: 'https://ma.wingie.com/zh/flights/to-miami/' },
                { title: '坎昆', href: 'https://ma.wingie.com/zh/flights/to-cancun/' },
                { title: '伦敦', href: 'https://ma.wingie.com/zh/flights/to-london/' },
                { title: '火奴鲁鲁', href: 'https://ma.wingie.com/zh/flights/to-honolulu/' },
            ],
        },
        {
            title: '热门国家',
            items: [
                { title: '加拿大', href: 'https://ma.wingie.com/zh/flights/ca-canada/' },
                { title: '中国', href: 'https://ma.wingie.com/zh/flights/cn-china/' },
                { title: '哥斯达黎加', href: 'https://ma.wingie.com/zh/flights/cr-costa-rica/' },
                { title: '多米尼加共和国', href: 'https://ma.wingie.com/zh/flights/do-dominican-republic/' },
                { title: '萨尔瓦多', href: 'https://ma.wingie.com/zh/flights/sv-el-salvador/' },
                { title: '法国', href: 'https://ma.wingie.com/zh/flights/fr-france/' },
            ],
        },
        {
            title: '热门航空公司',
            items: [
                { title: '美国航空', href: 'https://ma.wingie.com/zh/flights/airlines/american-airlines/' },
                { title: '达美航空', href: 'https://ma.wingie.com/zh/flights/airlines/delta-air-lines/' },
                { title: '美联航', href: 'https://ma.wingie.com/zh/flights/airlines/united-airlines/' },
                { title: '阿拉斯加航空', href: 'https://ma.wingie.com/zh/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://ma.wingie.com/zh/flights/airlines/jetblue/' },
                { title: '夏威夷航空', href: 'https://ma.wingie.com/zh/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'ma-ko': [
        {
            title: '인기 목적지',
            items: [
                { title: '라스베이거스', href: 'https://ma.wingie.com/ko/flights/to-las-vegas/' },
                { title: '시카고', href: 'https://ma.wingie.com/ko/flights/to-chicago/' },
                { title: '마이애미', href: 'https://ma.wingie.com/ko/flights/to-miami/' },
                { title: '칸쿤', href: 'https://ma.wingie.com/ko/flights/to-cancun/' },
                { title: '런던', href: 'https://ma.wingie.com/ko/flights/to-london/' },
                { title: '호놀룰루', href: 'https://ma.wingie.com/ko/flights/to-honolulu/' },
            ],
        },
        {
            title: '인기 국가',
            items: [
                { title: '캐나다', href: 'https://ma.wingie.com/ko/flights/ca-canada/' },
                { title: '중국', href: 'https://ma.wingie.com/ko/flights/cn-china/' },
                { title: '코스타리카', href: 'https://ma.wingie.com/ko/flights/cr-costa-rica/' },
                { title: '도미니카 공화국', href: 'https://ma.wingie.com/ko/flights/do-dominican-republic/' },
                { title: '엘살바도르', href: 'https://ma.wingie.com/ko/flights/sv-el-salvador/' },
                { title: '프랑스', href: 'https://ma.wingie.com/ko/flights/fr-france/' },
            ],
        },
        {
            title: '인기 항공사',
            items: [
                { title: '아메리칸 항공', href: 'https://ma.wingie.com/ko/flights/airlines/american-airlines/' },
                { title: '델타 항공', href: 'https://ma.wingie.com/ko/flights/airlines/delta-air-lines/' },
                { title: '유나이티드 항공', href: 'https://ma.wingie.com/ko/flights/airlines/united-airlines/' },
                { title: '알래스카 항공', href: 'https://ma.wingie.com/ko/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://ma.wingie.com/ko/flights/airlines/jetblue/' },
                { title: '하와이안 항공', href: 'https://ma.wingie.com/ko/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'ma-hi': [
        {
            title: 'लोकप्रिय गंतव्य',
            items: [
                { title: 'लास वेगास', href: 'https://ma.wingie.com/hi/flights/to-las-vegas/' },
                { title: 'शिकागो', href: 'https://ma.wingie.com/hi/flights/to-chicago/' },
                { title: 'मियामी', href: 'https://ma.wingie.com/hi/flights/to-miami/' },
                { title: 'कैनकन', href: 'https://ma.wingie.com/hi/flights/to-cancun/' },
                { title: 'लंदन', href: 'https://ma.wingie.com/hi/flights/to-london/' },
                { title: 'होनोलुलु', href: 'https://ma.wingie.com/hi/flights/to-honolulu/' },
            ],
        },
        {
            title: 'लोकप्रिय देश',
            items: [
                { title: 'कनाडा', href: 'https://ma.wingie.com/hi/flights/ca-canada/' },
                { title: 'चीन', href: 'https://ma.wingie.com/hi/flights/cn-china/' },
                { title: 'कोस्टा रिका', href: 'https://ma.wingie.com/hi/flights/cr-costa-rica/' },
                { title: 'डोमिनिकन गणराज्य', href: 'https://ma.wingie.com/hi/flights/do-dominican-republic/' },
                { title: 'अल सल्वाडोर', href: 'https://ma.wingie.com/hi/flights/sv-el-salvador/' },
                { title: 'फ्रांस', href: 'https://ma.wingie.com/hi/flights/fr-france/' },
            ],
        },
        {
            title: 'लोकप्रिय एयरलाइनें',
            items: [
                { title: 'अमेरिकन एयरलाइन्स', href: 'https://ma.wingie.com/hi/flights/airlines/american-airlines/' },
                { title: 'डेल्टा एयरलाइन्स', href: 'https://ma.wingie.com/hi/flights/airlines/delta-air-lines/' },
                { title: 'यूनाइटेड एयरलाइन्स', href: 'https://ma.wingie.com/hi/flights/airlines/united-airlines/' },
                { title: 'अलास्का एयरलाइन्स', href: 'https://ma.wingie.com/hi/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://ma.wingie.com/hi/flights/airlines/jetblue/' },
                { title: 'हवाई एयरलाइन्स', href: 'https://ma.wingie.com/hi/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'ma-ta': [
        {
            title: 'பிரபலமான இலக்குகள்',
            items: [
                { title: 'லாஸ் வெகாஸ்', href: 'https://ma.wingie.com/ta/flights/to-las-vegas/' },
                { title: 'சிகாகோ', href: 'https://ma.wingie.com/ta/flights/to-chicago/' },
                { title: 'மியாமி', href: 'https://ma.wingie.com/ta/flights/to-miami/' },
                { title: 'கான்கன்', href: 'https://ma.wingie.com/ta/flights/to-cancun/' },
                { title: 'லண்டன்', href: 'https://ma.wingie.com/ta/flights/to-london/' },
                { title: 'ஓனோலுலு', href: 'https://ma.wingie.com/ta/flights/to-honolulu/' },
            ],
        },
        {
            title: 'பிரபலமான நாடுகள்',
            items: [
                { title: 'கனடா', href: 'https://ma.wingie.com/ta/flights/ca-canada/' },
                { title: 'சீனா', href: 'https://ma.wingie.com/ta/flights/cn-china/' },
                { title: 'கோஸ்டா ரிக்கா', href: 'https://ma.wingie.com/ta/flights/cr-costa-rica/' },
                { title: 'டொமினிக்கன் குடியரசு', href: 'https://ma.wingie.com/ta/flights/do-dominican-republic/' },
                { title: 'எல் சால்வடோர்', href: 'https://ma.wingie.com/ta/flights/sv-el-salvador/' },
                { title: 'பிரான்சு', href: 'https://ma.wingie.com/ta/flights/fr-france/' },
            ],
        },
        {
            title: 'பிரபலமான விமான நிறுவனங்கள்',
            items: [
                { title: 'அமெரிக்கன் ஏர்லைன்ஸ்', href: 'https://ma.wingie.com/ta/flights/airlines/american-airlines/' },
                { title: 'டெல்டா ஏர்லைன்ஸ்', href: 'https://ma.wingie.com/ta/flights/airlines/delta-air-lines/' },
                { title: 'யுனைட்டட் ஏர்லைன்ஸ்', href: 'https://ma.wingie.com/ta/flights/airlines/united-airlines/' },
                { title: 'அலாஸ்கா ஏர்லைன்ஸ்', href: 'https://ma.wingie.com/ta/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://ma.wingie.com/ta/flights/airlines/jetblue/' },
                { title: 'ஹவாய் ஏர்லைன்ஸ்', href: 'https://ma.wingie.com/ta/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'ma-th': [
        {
            title: 'จุดหมายยอดนิยม',
            items: [
                { title: 'ลาสเวกัส', href: 'https://ma.wingie.com/th/flights/to-las-vegas/' },
                { title: 'ชิคาโก', href: 'https://ma.wingie.com/th/flights/to-chicago/' },
                { title: 'ไมอามี', href: 'https://ma.wingie.com/th/flights/to-miami/' },
                { title: 'แคนคูน', href: 'https://ma.wingie.com/th/flights/to-cancun/' },
                { title: 'ลอนดอน', href: 'https://ma.wingie.com/th/flights/to-london/' },
                { title: 'โฮโนลูลู', href: 'https://ma.wingie.com/th/flights/to-honolulu/' },
            ],
        },
        {
            title: 'ประเทศยอดนิยม',
            items: [
                { title: 'แคนาดา', href: 'https://ma.wingie.com/th/flights/ca-canada/' },
                { title: 'จีน', href: 'https://ma.wingie.com/th/flights/cn-china/' },
                { title: 'คอสตาริกา', href: 'https://ma.wingie.com/th/flights/cr-costa-rica/' },
                { title: 'สาธารณรัฐโดมินิกัน', href: 'https://ma.wingie.com/th/flights/do-dominican-republic/' },
                { title: 'เอลซัลวาดอร์', href: 'https://ma.wingie.com/th/flights/sv-el-salvador/' },
                { title: 'ฝรั่งเศส', href: 'https://ma.wingie.com/th/flights/fr-france/' },
            ],
        },
        {
            title: 'สายการบินยอดนิยม',
            items: [
                { title: 'อเมริกันแอร์ไลน์', href: 'https://ma.wingie.com/th/flights/airlines/american-airlines/' },
                { title: 'เดลต้า แอร์ไลน์', href: 'https://ma.wingie.com/th/flights/airlines/delta-air-lines/' },
                { title: 'ยูไนเต็ด แอร์ไลน์', href: 'https://ma.wingie.com/th/flights/airlines/united-airlines/' },
                { title: 'อลาสก้าแอร์ไลน์', href: 'https://ma.wingie.com/th/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://ma.wingie.com/th/flights/airlines/jetblue/' },
                { title: 'ฮาวายแอนแอร์ไลน์', href: 'https://ma.wingie.com/th/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'ma-ur': [
        {
            title: 'مشہور منزلیں',
            items: [
                { title: 'لاس ویگاس', href: 'https://ma.wingie.com/ur/flights/to-las-vegas/' },
                { title: 'شکاگو', href: 'https://ma.wingie.com/ur/flights/to-chicago/' },
                { title: 'میامی', href: 'https://ma.wingie.com/ur/flights/to-miami/' },
                { title: 'کینکن', href: 'https://ma.wingie.com/ur/flights/to-cancun/' },
                { title: 'لندن', href: 'https://ma.wingie.com/ur/flights/to-london/' },
                { title: 'ہونولولو', href: 'https://ma.wingie.com/ur/flights/to-honolulu/' },
            ],
        },
        {
            title: 'مشہور ممالک',
            items: [
                { title: 'کینیڈا', href: 'https://ma.wingie.com/ur/flights/ca-canada/' },
                { title: 'چین', href: 'https://ma.wingie.com/ur/flights/cn-china/' },
                { title: 'کوسٹا ریکا', href: 'https://ma.wingie.com/ur/flights/cr-costa-rica/' },
                { title: 'ڈومینیکن جمہوریہ', href: 'https://ma.wingie.com/ur/flights/do-dominican-republic/' },
                { title: 'ایل سیلواڈور', href: 'https://ma.wingie.com/ur/flights/sv-el-salvador/' },
                { title: 'فرانس', href: 'https://ma.wingie.com/ur/flights/fr-france/' },
            ],
        },
        {
            title: 'مشہور ایئر لائنز',
            items: [
                { title: 'امریکن ایئرلائنز', href: 'https://ma.wingie.com/ur/flights/airlines/american-airlines/' },
                { title: 'ڈیلٹا ایئر لائنز', href: 'https://ma.wingie.com/ur/flights/airlines/delta-air-lines/' },
                { title: 'یونائیٹڈ ایئرلائنز', href: 'https://ma.wingie.com/ur/flights/airlines/united-airlines/' },
                { title: 'الاسکا ایئرلائنز', href: 'https://ma.wingie.com/ur/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://ma.wingie.com/ur/flights/airlines/jetblue/' },
                { title: 'ہوائی ایئرلائنز', href: 'https://ma.wingie.com/ur/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'ma-ka': [
        {
            title: 'პოპულარული მიმართულებები',
            items: [
                { title: 'ლას-ვეგასი', href: 'https://ma.wingie.com/ka/flights/to-las-vegas/' },
                { title: 'ჩიკაგო', href: 'https://ma.wingie.com/ka/flights/to-chicago/' },
                { title: 'მაიამი', href: 'https://ma.wingie.com/ka/flights/to-miami/' },
                { title: 'კანკუნი', href: 'https://ma.wingie.com/ka/flights/to-cancun/' },
                { title: 'ლონდონი', href: 'https://ma.wingie.com/ka/flights/to-london/' },
                { title: 'ჰონოლულუ', href: 'https://ma.wingie.com/ka/flights/to-honolulu/' },
            ],
        },
        {
            title: 'პოპულარული ქვეყნები',
            items: [
                { title: 'კანადა', href: 'https://ma.wingie.com/ka/flights/ca-canada/' },
                { title: 'ჩინეთი', href: 'https://ma.wingie.com/ka/flights/cn-china/' },
                { title: 'კოსტა-რიკა', href: 'https://ma.wingie.com/ka/flights/cr-costa-rica/' },
                { title: 'დომინიკელთა რესპუბლიკა', href: 'https://ma.wingie.com/ka/flights/do-dominican-republic/' },
                { title: 'სალვადორი', href: 'https://ma.wingie.com/ka/flights/sv-el-salvador/' },
                { title: 'საფრანგეთი', href: 'https://ma.wingie.com/ka/flights/fr-france/' },
            ],
        },
        {
            title: 'პოპულარული ავიაკომპანიები',
            items: [
                { title: 'ამერიკის ავიაკომპანია', href: 'https://ma.wingie.com/ka/flights/airlines/american-airlines/' },
                { title: 'დელტა ეარ ლაინზი', href: 'https://ma.wingie.com/ka/flights/airlines/delta-air-lines/' },
                { title: 'იუნაიტედ ერლაინზი', href: 'https://ma.wingie.com/ka/flights/airlines/united-airlines/' },
                { title: 'ალასკას ავიაკომპანია', href: 'https://ma.wingie.com/ka/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://ma.wingie.com/ka/flights/airlines/jetblue/' },
                { title: 'ჰავაუს ავიაკომპანია', href: 'https://ma.wingie.com/ka/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ]
}